import $ from 'jquery';
import 'jquery-migrate';
import * as Track from '../tracking/track.js';
import '../../Js/bootstrap.min.js';
import '../exclusive_popover/init.js';
import 'ext/elasticsearch/Resources/Public/Js/topsearch.js';

export function init() {

}
